
import React, { useState } from "react";
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import StarIcon from '@mui/icons-material/Star';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Rating from '@mui/material/Rating';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Link as materialLink } from '@mui/material/Link';
import { Link, useNavigate } from 'react-router-dom';
import { green, red, grey, purple } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { PDFDownloadLink, Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import resumePdf from "./TommasoFrambaResume2023.pdf";
import CardActionArea from '@mui/material/CardActionArea';


const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

function Copyright() {
  return (
    <Stack
    sx={{ pb: 1 }}
    direction="row"
    spacing={2}
    justifyContent="center"
  >
    {/* <Button variant="contained">Contact</Button> */}
    <Button variant="text" color="custom3" href="https://mail.google.com/mail/?view=cm&fs=1&to=frambatom@gmail.com">Email</Button>
    <Button variant="text" color="custom3" href="https://www.linkedin.com/in/tommaso-framba-a9a7a5199/">LinkedIn</Button>
    <Button variant="text" color="custom3" href="https://github.com/TommasoFramba">Github</Button>
  </Stack>
  );
}

const onDownload = () => {
  const link = document.createElement("a");
  link.download = `TommasoFrambaResume2022.pdf`;
  link.href = "./TommasoFrambaResume2022.pdf";
  link.click();
};


const theme = createTheme({
  palette: {
    text: {
      primary: '#FAFAFA',
      secondary: '#BDBDBD',
    },
    background: {
      default: "#061b2b",
    },
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
    custom1: {
      light: "#ff6158",
      main: "#e7222e",
      contrastText: "#ffffff",
      dark: "#ac0006",
    },
    custom2: {
      light: "#5284bf",
      main: "#29b6f6",
      contrastText: "#ffffff",
      dark: "#0086c3",
    },
    custom3: {
      light: "#5284bf",
      main: "#4b94cc",
      contrastText: "#ffffff",
      dark: "#002f60",
    }
  },
  neutral: {
    main: '#64748B',
    contrastText: '#fff',
  },
});

var cardStyle = {
  display: 'block',
  width: '30vw',
  transitionDuration: '0.3s',
  height: '50vw'
}

export default function Projects() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        {/* Hero unit */}
       
          <Typography
        sx={{
          pt: 6,
          pb: 0,
        }}
            variant="h4"
            align="center"
            color="text.primary"
            component="p"
          >
            Released Projects
          </Typography>
          <Typography
        sx={{
          pt: 0,
          pb: 6,
        }}
            variant="p"
            align="center"
            color="text.secondary"
            component="p"
          >
            Projects that I am proud of. Schoolwork and more can be found on my Github.
          </Typography>
          
          <Container maxWidth="sm">
            <Container
              component="img"
              display='flex'
              alignItems='center'
              justifyContent='center'
              style={{
                minWidth: 200,
                maxWidth: 300,
                borderRadius: 80
              }}
              maxWidth="lg"
              alt="Profile Picture"
              src="https://i.imgur.com/KrQcjAq.png">
                </Container></Container>
                <Typography
        sx={{
          pt: 1,
          pb: 0,
        }}
            variant="h5"
            align="center"
            color="text.primary"
            component="p"
          >
            Enthusiast Search
          </Typography>
          <Typography
        sx={{
          pt: 0,
          pb: 1,
        }}
            variant="p"
            align="center"
            color="text.secondary"
            component="p"
          >
            Released 2022
          </Typography>
          <Stack
              sx={{ pt: 0 }}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              {/* <Button variant="contained">Contact</Button> */}
              <Button 
              sx = {{
                backgroundImage: "linear-gradient(45deg,#81d4fa,#0288d1)",
                '&:hover': {
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              
              variant="contained" color="custom2" href="https://apps.apple.com/app/enthusiast-search/id1631774125">App Store</Button>
              <Button sx = {{
                backgroundImage: "linear-gradient(45deg,#1b5e20,#4caf50)",
                '&:hover': {
                  opacity: [0.9, 0.8, 0.7],
                },
              }}variant="contained" color="custom1" href = "https://play.google.com/store/apps/details?id=com.framba.area51">Play Store</Button>
            </Stack>

          <Container maxWidth="sm"
          sx={{
            pt: 8,
            pb: 1,
          }}>
            <Container
              component="img"
              display='flex'
              alignItems='center'
              justifyContent='center'
              style={{
                minWidth: 200,
                maxWidth: 300,
                borderRadius: 80
              }}
              maxWidth="lg"
              alt="Profile Picture"
              src="https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/65/c2/b5/65c2b5e7-1bd8-d0a9-185f-7fd2ef2c16d5/AppIcon-0-1x_U007emarketing-0-85-220-7.png/1024x1024bb.png">
                </Container></Container>
                
                <Typography
        sx={{
          pt: 1,
          pb: 0,
        }}
            variant="h5"
            align="center"
            color="text.primary"
            component="p"
          >
            Twisty Leaf
          </Typography>
                <Typography
        sx={{
          pt: 0,
          pb: 1,
        }}
            variant="p"
            align="center"
            color="text.secondary"
            component="p"
          >
            Released 2019
          </Typography>
          <Stack
              sx={{ pt: 0 }}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              {/* <Button variant="contained">Contact</Button> */}
              <Button sx = {{
                backgroundImage: "linear-gradient(45deg,#81d4fa,#0288d1)",
                '&:hover': {
                  opacity: [0.9, 0.8, 0.7],
                },
              }} variant="contained" color="custom2" href="https://apps.apple.com/us/app/twisty-leaf/id1480334787?ls=1&hmsr=joyk.com&utm_source=joyk.com&utm_medium=referral">App Store</Button>
              <Button sx = {{
                backgroundImage: "linear-gradient(45deg,#1b5e20,#4caf50)",
                '&:hover': {
                  opacity: [0.9, 0.8, 0.7],
                },
              }}variant="contained" color="custom1" href="https://play.google.com/store/apps/details?id=com.framba.leafgameV1&hl=en_US&gl=US">Play Store</Button>
            </Stack>



      </main>
      {/* Footer */}
      <Box sx={{ bgcolor: 'primary', p: 6 }} component="footer">
        <Typography variant="h6" align="center" gutterBottom>
          Contact
        </Typography>
        
        <Copyright />
        <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <materialLink color="inherit" href="https://github.com/TommasoFramba">
        Tommaso Framba
      </materialLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
      </Box>
      {/* End footer */}
    </ThemeProvider>
  );
}